module.exports = __webpack_public_path__ + "img/main-04-04-more.c1763d6e.png";